import { DialogContent, FormHelperText, TextareaAutosize } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import useStyles from './statusChange.styles'
import { STATUS_CANCELED_ID } from 'constants/ordersContants'

const ChangeReasonStep = ({ reason, onReasonChange, reasonType }) => {
  const classes = useStyles()

  return (
    <div className={classes.confirmationContainer}>
      <DialogContent style={{ overflowX: 'hidden' }}>
        <p>
          Escriba el motivo de {reasonType === STATUS_CANCELED_ID ? 'cancelación' : 'completación'}{' '}
          del producto:
        </p>

        <TextareaAutosize
          maxLength={250}
          minRows={3}
          value={reason}
          className={classes.reason}
          placeholder={`Describa brevemente las razones para el cambio de estado del producto (máx. 250 caracteres)`}
          onChange={(e) => {
            onReasonChange(e.target.value)
          }}
        />
        <FormHelperText style={{ color: reason.length < 250 ? 'black' : 'red' }}>
          {reason.length}
          /250
        </FormHelperText>
      </DialogContent>
    </div>
  )
}

ChangeReasonStep.propTypes = {
  onReasonChange: PropTypes.func,
  reasonType: PropTypes.string,
}

export default ChangeReasonStep
